<div class="main-container" [attr.data-testid]="vm.slug">
  <div class="content">
    <div class="text-container">
      <span class="title">{{ vm.title }}</span>
      <div class="divider-line"></div>
      <span class="description">{{ vm.description }}</span>
    </div>

    <div class="asset-images-container">
      <div class="asset-image-with-text">
        <img osnSharedUseAsPicture [imgQuery]="assetImgQuery" [src]="vm.firstAssetImageUrl" />
        <span class="asset-image-text">{{ vm.firstAssetImageText }}</span>
      </div>

      <div class="asset-image-with-text">
        <img osnSharedUseAsPicture [imgQuery]="assetImgQuery" [src]="vm.secondAssetImageUrl" />
        <span class="asset-image-text">{{ vm.secondAssetImageText }}</span>
      </div>
    </div>

    <osn-shared-marketing-action-button
      *ngIf="vm.button"
      [actionButton]="vm.button"
      [buttonText]="buttonText"
      data-testid="LandingPage.mlpKidsButton"
      (measureClick)="onKidsTrayButtonClick()"
    ></osn-shared-marketing-action-button>

    <div class="kids-left">
      <div class="position-relative w-100 h-100 kids-left-3d-space">
        <img
          class="kids-image-landscape"
          *ngFor="let url of vm.leftImageUrls"
          [src]="url"
          data-testid="MarketingLandingPage.kidsTrayContainerImagesLeft"
        />
      </div>
    </div>

    <div class="kids-right">
      <div class="position-relative w-100 h-100 kids-right-3d-space">
        <img
          class="kids-image-portrait"
          *ngFor="let url of vm.rightImageUrls"
          [src]="url"
          data-testid="MarketingLandingPage.kidsTrayContainerImagesRight"
        />
      </div>
    </div>
  </div>
</div>
